import type { CategoryGridItem, HomePageViewModel } from "src/http/types";
import { ENTITY_TYPES } from "src/website-apps/shared/components/grid/favorites-fs/constants";

export const resolveInitialFavoritesState = (
  model: HomePageViewModel,
): Record<number, Record<number, boolean | undefined>> => {
  const performers: CategoryGridItem[] = [
    ...(model.concerts.categoryItems?.items ?? []),
    ...(model.theater.categoryItems?.items ?? []),
    ...(model.sports.categoryItems?.items ?? []),
    ...(model.recentlyViewedItems?.output ?? []),
    ...(model.festival?.categoryItems?.items ?? []),
    ...model.heroBannerContent,
    ...(model.connectToSpotify?.options?.items ?? []),
  ];
  const events = [
    ...(model.trendingEventsLocaleItems.items ?? []),
    ...(model.recommendedBasedOnFavoriteEvents?.items ?? []),
    ...(model.savedEvents.items ?? []),
  ];
  const performerFavorites = performers.reduce(
    (acc: Record<number, Record<number, boolean | undefined>>, curr) => ({
      ...acc,
      [ENTITY_TYPES.CATEGORY]: {
        ...acc[ENTITY_TYPES.CATEGORY],
        ...(curr.categoryId && { [curr.categoryId]: curr.isFavorite }),
      },
    }),
    {},
  );
  const eventFavorites = events.reduce(
    (acc: Record<number, Record<number, boolean | undefined>>, curr) => ({
      ...acc,
      [ENTITY_TYPES.EVENT]: {
        ...acc[ENTITY_TYPES.EVENT],
        ...(curr.eventId && { [curr.eventId]: curr.isFavorite }),
      },
    }),
    {},
  );
  return {
    ...performerFavorites,
    ...eventFavorites,
  };
};
